import { serverApi } from './api';

const API = '/api/downline';

export const getDownlineListApi = () => serverApi.get(`${API}/list`).then((res) => res.data.data);

export const postDownlineEditCreditApi = (body) =>
	serverApi.post(`${API}/editcredit`, body).then((res) => res.data.data);
